import { Header, Button, Badge, SpaceBetween } from "@cloudscape-design/components"
import PERMISSIONS from "configs/Permissions"
import { disabledButtonReason } from "configs/settings"
import UserService from "services/UserService"
import { DeploymentsTable } from "./DeploymentsTable"
import { DeploymentItem } from "types/deploymentTypes"

interface DeploymentProps{
    deploymentType : "shared" | "dedicated";
    tableDescription : string;
    badgeText : string;
    title : string;
    createButtonText : string;
    handleOpenCreatePage : ()=>void;
    deploymentsList : DeploymentItem[];
    columnDefinitions : any[];
    columnDisplayOrder : any[];
    isLoadingDeployments : boolean;
    loadingDeploymentsError : string | null;
    handleLoadingData: ()=>Promise<void>;
}

function DeploymentPage({deploymentType, tableDescription, badgeText, title, createButtonText, handleOpenCreatePage, deploymentsList, columnDefinitions, columnDisplayOrder, isLoadingDeployments, loadingDeploymentsError, handleLoadingData}: DeploymentProps) {
    const isShared = deploymentType === "shared";
  return (
    <SpaceBetween size="l">

      <Header
        variant="h1"
        description={tableDescription}
        actions={
          <Button
            variant="primary"
            disabled={!UserService.hasRole([PERMISSIONS.DEPLOYMENTS.MANAGE_CLUSTERS])}
            disabledReason={disabledButtonReason}
            onClick={handleOpenCreatePage}
          >
            {createButtonText}
          </Button>
        }
        info={
          <div className="clustersHeader">
            <Badge color={isShared ? "blue" : "green"}><span className="no-wrap-text">{badgeText}</span></Badge>
            <span className="no-wrap-text">{title}</span>
            <span className="no-wrap-text">{`(${deploymentsList.length})`}</span>
            <Button variant="icon" iconName="refresh" onClick={handleLoadingData} disabled={isLoadingDeployments} />
          </div>
        }
      />

      <DeploymentsTable
        columnDefinitions={columnDefinitions}
        deploymentType={deploymentType}
        columnDisplayOrder={columnDisplayOrder}
        deploymentsList={deploymentsList}
        isLoadingDeployments={isLoadingDeployments}
        loadingDeploymentsError={loadingDeploymentsError}
      />

    </SpaceBetween>
  )
}

export default DeploymentPage
